/** Шар из макета hero: фоновая графика, не участвует в раскладке. */
export function HeroOrb({ className = '' }: { className?: string }) {
  return (
    <svg
      aria-hidden
      className={className}
      viewBox="860 170 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <linearGradient id="hero-orb-body" x1="874.154" y1="182.154" x2="1261.85" y2="569.846" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2B6BFF" />
          <stop offset="0.55" stopColor="#4C93FF" />
          <stop offset="1" stopColor="#5BB6FF" />
        </linearGradient>
        <radialGradient id="hero-orb-deep" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1162.55 479.169) scale(116.308 99.0769)">
          <stop stopColor="#1F4FD1" stopOpacity="0.8" />
          <stop offset="1" stopColor="#1F4FD1" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="hero-orb-sky" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1011.35 442.769) scale(107.692 90.4615)">
          <stop stopColor="#7AD3FF" stopOpacity="0.95" />
          <stop offset="1" stopColor="#7AD3FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="hero-orb-gold" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(989.169 358.985) scale(73.2308 60.3077)">
          <stop stopColor="#E3C98A" stopOpacity="0.8" />
          <stop offset="1" stopColor="#E3C98A" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="hero-orb-gloss" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1003.38 289.846) scale(99.0769 58.1538)">
          <stop stopColor="white" stopOpacity="0.9" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>
      <path
        d="M1266.15 376C1270.85 404.668 1272.25 441.972 1260.6 468.745C1248.92 495.517 1220.84 519.748 1196.13 536.655C1171.43 553.585 1140.8 565.926 1112.35 570.277C1083.87 574.606 1052.32 570.6 1025.38 562.717C998.452 554.855 973.618 539.735 950.723 523.065C927.806 506.394 901.443 487.203 887.982 462.692C874.498 438.181 869.351 404.668 869.846 376C870.342 347.332 879.582 317.868 890.975 290.751C902.348 263.612 916.283 232.295 938.188 213.234C960.092 194.151 993.498 181.249 1022.42 176.36C1051.37 171.471 1084.43 175.477 1111.85 183.898C1139.27 192.298 1166.86 208 1186.98 226.825C1207.07 245.628 1219.26 271.926 1232.47 296.803C1245.67 321.658 1261.46 347.332 1266.15 376Z"
        fill="url(#hero-orb-body)"
      />
      <path
        d="M1162.55 578.246C1226.79 578.246 1278.86 533.888 1278.86 479.169C1278.86 424.451 1226.79 380.092 1162.55 380.092C1098.32 380.092 1046.25 424.451 1046.25 479.169C1046.25 533.888 1098.32 578.246 1162.55 578.246Z"
        fill="url(#hero-orb-deep)"
      />
      <path
        d="M1011.35 533.231C1070.83 533.231 1119.05 492.73 1119.05 442.769C1119.05 392.809 1070.83 352.308 1011.35 352.308C951.877 352.308 903.662 392.809 903.662 442.769C903.662 492.73 951.877 533.231 1011.35 533.231Z"
        fill="url(#hero-orb-sky)"
      />
      <path
        d="M989.169 419.292C1029.61 419.292 1062.4 392.292 1062.4 358.985C1062.4 325.678 1029.61 298.677 989.169 298.677C948.725 298.677 915.938 325.678 915.938 358.985C915.938 392.292 948.725 419.292 989.169 419.292Z"
        fill="url(#hero-orb-gold)"
      />
      <path
        opacity="0.75"
        d="M1003.38 348C1058.1 348 1102.46 321.964 1102.46 289.846C1102.46 257.729 1058.1 231.692 1003.38 231.692C948.666 231.692 904.308 257.729 904.308 289.846C904.308 321.964 948.666 348 1003.38 348Z"
        fill="url(#hero-orb-gloss)"
      />
      <path
        d="M1266.15 376C1270.85 404.668 1272.25 441.972 1260.6 468.745C1248.92 495.517 1220.84 519.748 1196.13 536.655C1171.43 553.585 1140.8 565.926 1112.35 570.277C1083.87 574.606 1052.32 570.6 1025.38 562.717C998.452 554.855 973.618 539.735 950.723 523.065C927.806 506.394 901.443 487.203 887.982 462.692C874.498 438.181 869.351 404.668 869.846 376C870.342 347.332 879.582 317.868 890.975 290.751C902.348 263.612 916.283 232.295 938.188 213.234C960.092 194.151 993.498 181.249 1022.42 176.36C1051.37 171.471 1084.43 175.477 1111.85 183.898C1139.27 192.298 1166.86 208 1186.98 226.825C1207.07 245.628 1219.26 271.926 1232.47 296.803C1245.67 321.658 1261.46 347.332 1266.15 376Z"
        strokeWidth="21"
        stroke="white"
        strokeOpacity="0.6"
      />
    </svg>
  );
}
